/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createIngestConsumerCustomerWithContractOrchestrationResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type IngestConsumerCustomerWithContractOrchestrationResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ingests/consumer-customers
 */
export interface ConsumerCustomersRequestBuilder extends BaseRequestBuilder<ConsumerCustomersRequestBuilder> {
    /**
     * IngestConsumerCustomers
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<IngestConsumerCustomerWithContractOrchestrationResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<ConsumerCustomersRequestBuilderPostQueryParameters> | undefined) : Promise<IngestConsumerCustomerWithContractOrchestrationResult | undefined>;
    /**
     * IngestConsumerCustomers
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<ConsumerCustomersRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * IngestConsumerCustomers
 */
export interface ConsumerCustomersRequestBuilderPostQueryParameters {
    verifyOnly?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const ConsumerCustomersRequestBuilderUriTemplate = "{+baseurl}/ingests/consumer-customers{?verifyOnly*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ConsumerCustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ConsumerCustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createIngestConsumerCustomerWithContractOrchestrationResultFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
